import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';

import { history } from '../../../_services/essentials/helpers';
import { userActions, alertActions, breadcrumbsActions } from '../../../_services/essentials/store';
import Typography from "@mui/material/Typography";
import { Button, FormControl, FormHelperText, MenuItem, Select, Stack, TextField, InputAdornment } from "@mui/material";
import MuiCard from '@mui/material/Card';
import { styled } from '@mui/material/styles';

import { Visibility, VisibilityOff } from '@mui/icons-material';
const Card = styled(MuiCard)(({ theme }) => ({
    padding: theme.spacing(3),
    gap: theme.spacing(2),
    margin: 'auto',
    borderRadius: '8px', // Rounded corners
    background: 'var(--Neutral-White, #FFF)', // Background color
    boxShadow: '0px 12px 26px 0px rgba(16, 30, 115, 0.06)', // Floating shadow
    [theme.breakpoints.up('sm')]: {
        width: '65%',
    },
}));

export { AddEdit };

function AddEdit() {


    const [showPassword, setShowPassword] = useState({
        newPassword: false,
        confirmPassword: false,
    });


    const handleTogglePassword = (field) => {
        setShowPassword((prev) => ({
            ...prev,
            [field]: !prev[field],
        }));
    };
    //const entity_name = "user";
    //const entity_label = "User";
    //const entities_name = "users";
    //const entities_label = "Users";

    const { id } = useParams();
    const dispatch = useDispatch();

    const entity = useSelector(x => x.users?.item);
    const statuses = useSelector(x => x.users?.statuses);
    const customers = useSelector(x => x.users?.customers);
    const account_roles = useSelector(x => x.users?.account_roles);
    // form validation rules
    const validationSchema = Yup.object().shape({
        firstname: Yup.string().trim()
            .required("Required*").max(45, 'Cannot exceed 45 characters'),
        lastname: Yup.string().trim()
            .required('Required*').max(45, 'Cannot exceed 45 characters'),
        customer: Yup.object({
            id: Yup.string()
                .trim()
                // .required('Required*')
                .notOneOf(['-1'], 'Required*'),
        }),
        roles: Yup.array()
            .of(
                Yup.object({
                    id: Yup.string()
                        .trim()
                        .notOneOf(['-1'], 'Required*')
                    // .required('Required*'),
                })
            )
            .required('Roles are required*'),
        email: Yup.string().trim().email("Please enter a Email")
            .required('Required*').max(60, 'Cannot exceed 60 characters'),
        //phone: Yup.string()
        //    .required('Required*'),
        phone: Yup.string()
            .matches(
                /^[0-9]+$/,
                'Please enter a valid Phone number'
            ),
        password: Yup.string().trim().when('id', {
            is: (val) => {
                return !val;
            },
            then: (schema) => schema.required("Required*").min(6, 'Password must be at least 6 characters').max(50, 'Cannot exceed 50 characters'),
            otherwise: (schema) => schema.notRequired(),
        }),
        confirmPassword: Yup.string().trim().when('id', {
            is: (val) => {
                return !val;
            },
            then: (schema) => schema.required("Required*")
                .oneOf([Yup.ref('password'), null], 'Password and Confirm Password must match').max(50, 'Cannot exceed 50 characters'),
            otherwise: (schema) => schema.notRequired(),
        }),
        totalKOLLicensesUsed: Yup.number().nullable(),
        totalKOLLicensesBought: Yup.number()
            .min(0)
            .typeError("Required")
            .notRequired()
            .when("totalKOLLicensesUsed", (totalKOLLicensesUsed, schema) => {
                return schema.test({
                    test: (totalKOLLicensesBought) => {
                        return totalKOLLicensesBought >= totalKOLLicensesUsed;
                    },
                    message: "Total Licenses bought must be greater than or equal to Licenses used",
                });
            }),
    });
    const formOptions = { resolver: yupResolver(validationSchema) };

    // get functions to build form with useForm() hook
    const { register, handleSubmit, reset, formState, control } = useForm(formOptions);
    const { errors } = formState;
    const accessTo = useSelector(x => x.auth.accessTo);

    useEffect(() => {
        dispatch(breadcrumbsActions.setCurrentTitle(`Users`));
        if (id) {
            // fetch user details into redux state and
            // populate form fields with reset()
            dispatch(userActions.getById(id)).unwrap()
                .then(user => {
                    reset(user);
                });

        } else {
            const newEntity = {
                firstname: "",
                lastname: "",
                email: "",
                phone: "",
                password: "",
                confirmPassword: "",
                totalKOLLicensesBought: 500,
                totalKOLLicensesUsed: 0,
                customer: {
                    id: -1
                },
                accountStatus: {
                    id: 1
                },
                roles: [
                    {
                        id: -1
                    }
                ]
            };
            dispatch(userActions.getNewEntity(newEntity)).unwrap()
                .then(user => {
                    reset(user);
                });
        }
    }, [id, dispatch, reset]);

    useEffect(() => {
        dispatch(userActions.getAllStatuses());
        dispatch(userActions.getAllCustomers());
        dispatch(userActions.getAllAccountRoles());
    }, [dispatch]);


    async function onSubmit(data) {
        dispatch(alertActions.clear());
        try {
            // create or update user based on id param
            let message;
            if (id) {
                await dispatch(userActions.update({ id, data })).unwrap();
                //TODO: Make use of return value. and display message based on return value
                message = 'User account is updated now';
                dispatch(alertActions.success({ message, showAfterRedirect: false }));


            } else {
                const response = await dispatch(userActions.register(data)).unwrap();
                dispatch(alertActions.error(response));
                //TODO: Make use of return value. and display message based on return value
                message = response;
                //message = 'User added';
                history.navigate('/users');
                // redirect to user list with success message
                dispatch(alertActions.success({ message, showAfterRedirect: true }));
            }


        } catch (error) {
            dispatch(alertActions.error(error));
        }
    }

    return (
        <React.Fragment>
            <Card sx={{
                ml: 2
            }}>
                <Stack
                    sx={{
                        // minWidth: '900px',
                        // width: '65%',
                        justifyContent: 'space-between', flexGrow: '1', gap: 1
                    }}
                >
                    {/* <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
                    <ArrowLeftIcon onClick={() => history.navigate(-1)} sx={{ fontSize: '48px', mb: 0.5, cursor: 'pointer' }} />{id ? `${entity_label}` : `Add New ${entity_label}`}
                </Typography> */}
                    {!(entity?.loading || entity?.error) &&
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Stack direction="column" size={{ xs: 12, sm: 12, md: 12, lg: 12 }} sx={{ flexGrow: '1', gap: 1 }}>
                                <Stack direction="row" sx={{ flexGrow: '1', gap: 1 }} >
                                    <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>First name<span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                    <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Last name<span style={{ color: 'red' }}>*</span></Typography>
                                </Stack>
                                <Stack direction="row" sx={{ flexGrow: '1', gap: 1 }}>

                                    <TextField
                                        id="firstname"
                                        name="firstname"
                                        type="text"
                                        variant='outlined'
                                        color='primary'
                                        // label="First name*"
                                        placeholder={""}
                                        autoComplete="off"
                                        fullWidth
                                        sx={{ mb: 1.5 }}
                                        inputlabelprops={{ shrink: true }}
                                        {...register('firstname', { required: true })}
                                        error={Boolean(errors.firstname)}
                                        helperText={errors.firstname ? errors.firstname.message : ""}
                                        inputProps={{
                                            maxLength: 45,
                                        }}
                                    />
                                    <TextField
                                        id="lastname"
                                        name="lastname"
                                        type="text"
                                        variant='outlined'
                                        color='primary'
                                        // label="Last name*"
                                        placeholder={""}
                                        autoComplete="off"
                                        fullWidth
                                        sx={{ mb: 1.5 }}
                                        inputlabelprops={{ shrink: true }}
                                        {...register('lastname', { required: true })}
                                        error={Boolean(errors.lastname)}
                                        helperText={errors.lastname ? errors.lastname.message : ""}
                                        inputProps={{
                                            maxLength: 45,
                                        }}
                                    />
                                </Stack>
                                <Stack direction="row" sx={{ flexGrow: '1', gap: 1 }} >
                                    <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Email<span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                    <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Phone<span style={{ color: 'red' }}>*</span></Typography>
                                </Stack>
                                <Stack direction="row" sx={{ flexGrow: '1', gap: 1 }}>
                                    <TextField
                                        id="email"
                                        name="email"
                                        type="text"
                                        variant='outlined'
                                        color='primary'
                                        // label="Email*"
                                        placeholder={""}
                                        autoComplete="off"
                                        fullWidth
                                        sx={{ mb: 1.5 }}
                                        inputlabelprops={{ shrink: true }}
                                        {...register('email', { required: true })}
                                        error={Boolean(errors.email)}
                                        helperText={errors.email ? errors.email.message : ""}
                                        inputProps={{
                                            maxLength: 60,
                                        }}
                                    />
                                    <TextField
                                        id="phone"
                                        name="phone"
                                        type="text"
                                        variant='outlined'
                                        color='primary'
                                        // label="Phone*"
                                        placeholder={""}
                                        autoComplete="off"
                                        fullWidth
                                        sx={{ mb: 1.5 }}
                                        inputlabelprops={{ shrink: true }}
                                        {...register('phone', { required: true })}
                                        inputProps={{
                                            maxLength: 45,
                                        }}
                                        error={Boolean(errors.phone)}
                                        helperText={errors.phone ? errors.phone.message : ""}
                                    />
                                </Stack>
                                <Stack direction="row" sx={{ flexGrow: '1', gap: 1 }} >
                                    <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Customer<span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                    <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Role<span style={{ color: 'red' }}>*</span></Typography>
                                </Stack>
                                <Stack direction="row" sx={{ flexGrow: '1', gap: 1, mb: 1.5, minHeight: '100%' }}>

                                    {!(customers?.loading || customers?.error) &&

                                        <Controller
                                            name="customer.id"
                                            control={control}
                                            defaultValue={entity?.value?.customer?.id || "-1"}
                                            render={({ field }) => (
                                                <FormControl fullWidth error={Boolean(errors.customer?.id)}>
                                                    <Select
                                                        {...field}
                                                        labelId="select-customer.id-label"
                                                        id="customer.id"
                                                        name="customer.id"
                                                        inputlabelprops={{ shrink: true }}

                                                        sx={{
                                                            border: 0, height: '40px', maxWidth: '350px', backgroundColor: '#fff', '&:hover': {
                                                                backgroundColor: '#fff'
                                                            },
                                                        }}
                                                    // error={Boolean(errors.customer.id)}
                                                    >
                                                        <MenuItem key={-1} value={-1}>
                                                            -Select-
                                                        </MenuItem>


                                                        {customers?.value?.map((customer) => (
                                                            <MenuItem key={customer.id} value={customer.id}>{customer.organizationName}</MenuItem>
                                                        ))}
                                                    </Select>
                                                    {errors.customer?.id && (
                                                        <FormHelperText

                                                        >{errors.customer.id.message}</FormHelperText>
                                                    )}
                                                </FormControl>
                                            )}
                                        />
                                    }
                                    {!(account_roles?.loading || account_roles?.error) &&
                                        < Controller
                                            name="roles[0].id"
                                            control={control}
                                            // defaultValue={1}

                                            render={({ field }) => (
                                                <FormControl fullWidth error={Boolean(errors.roles?.[0]?.id)}>
                                                    <Select
                                                        {...field}
                                                        labelId="select-role-0-label"
                                                        id="role-0"
                                                        // name="role.id"
                                                        inputlabelprops={{ shrink: true }}

                                                        sx={{
                                                            border: 0, height: '40px', maxWidth: '350px', backgroundColor: '#fff', '&:hover': {
                                                                backgroundColor: '#fff'
                                                            },
                                                        }}
                                                    // error={Boolean(errors.customer.id)}
                                                    >
                                                        {console.log(entity?.value?.roles[0]?.id)}
                                                        <MenuItem key={-1} value={-1}>
                                                            -Select-
                                                        </MenuItem>
                                                        {!(account_roles?.loading || account_roles?.error) && account_roles?.value?.map((role) => (
                                                            <MenuItem key={role.id} value={role.id}>{role.displayName}</MenuItem>
                                                        ))}
                                                    </Select>
                                                    {errors.roles?.[0]?.id && (
                                                        <FormHelperText>{errors.roles[0].id.message}</FormHelperText>
                                                    )}
                                                </FormControl>
                                            )}
                                            defaultValue={entity?.value?.roles[0]?.id || "-1"}

                                        />
                                    }

                                </Stack>
                                {id &&
                                    <>
                                        <Stack direction="row" sx={{ flexGrow: '1', gap: 1 }} >
                                            <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Total Licenses Bought<span style={{ color: 'red' }}>*</span>
                                            </Typography>
                                            <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Total Licenses Used (Read only)</Typography>
                                        </Stack>
                                        <Stack direction="row" sx={{ flexGrow: '1', gap: 1 }}>
                                            {accessTo.ADMIN_AND_ABOVE &&
                                                <TextField
                                                    id="totalKOLLicensesBought"
                                                    name="totalKOLLicensesBought"
                                                    type="number"
                                                    variant='outlined'
                                                    color='primary'
                                                    // label="Total Licenses Bought*"
                                                    placeholder={""}
                                                    autoComplete="off"
                                                    fullWidth
                                                    sx={{ mb: 1.5 }}
                                                    inputlabelprops={{ shrink: true }}
                                                    {...register('totalKOLLicensesBought', { required: true })}
                                                    error={Boolean(errors.totalKOLLicensesBought)}
                                                    helperText={errors.totalKOLLicensesBought ? errors.totalKOLLicensesBought.message : ""}
                                                    inputProps={{
                                                        maxLength: 10,
                                                    }}
                                                />
                                            }
                                            {!accessTo.ADMIN_AND_ABOVE &&
                                                <TextField
                                                    id="totalKOLLicensesBought"
                                                    name="totalKOLLicensesBought"
                                                    type="number"
                                                    variant='outlined'
                                                    color='primary'
                                                    // label="Total Licenses Bought (Read only)"
                                                    placeholder={""}
                                                    autoComplete="off"
                                                    fullWidth
                                                    sx={{ mb: 1.5 }}
                                                    inputlabelprops={{ shrink: true }}
                                                    value={entity?.value?.totalKOLLicensesBought}
                                                    readOnly
                                                />
                                            }
                                            <TextField
                                                id="totalKOLLicensesUsed"
                                                name="totalKOLLicensesUsed"
                                                type="number"
                                                variant='outlined'
                                                color='primary'
                                                // label="Total Licenses Used (Read only)"
                                                placeholder={""}
                                                autoComplete="off"
                                                fullWidth
                                                sx={{ mb: 1.5 }}
                                                inputlabelprops={{ shrink: true }}
                                                value={entity?.value?.totalKOLLicensesUsed}
                                                readOnly
                                            />
                                        </Stack>
                                    </>
                                }
                                {!id && accessTo.ADMIN_AND_ABOVE &&
                                    <>
                                        <Stack direction="row" sx={{ flexGrow: '1', gap: 1 }} >
                                            <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Password<span style={{ color: 'red' }}>*</span>
                                            </Typography>
                                            <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Confirm Password<span style={{ color: 'red' }}>*</span></Typography>
                                        </Stack>
                                        <Stack direction="row" sx={{ flexGrow: '1', gap: 1 }}>
                                            <FormControl fullWidth>
                                                <TextField
                                                    id="password"
                                                    name="password"
                                                    // type="password"
                                                    type={showPassword.newPassword ? 'text' : 'password'}
                                                    variant='outlined'
                                                    color='primary'
                                                    // label="Password*"
                                                    placeholder={""}
                                                    autoComplete="off"
                                                    sx={{ mb: 1.5 }}
                                                    inputlabelprops={{ shrink: true }}
                                                    {...register('password', { required: true })}
                                                    error={Boolean(errors.password)}
                                                    helperText={errors.password ? errors.password.message : ""}
                                                    inputProps={{
                                                        maxLength: 50,
                                                    }}
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <div
                                                                    style={{
                                                                        cursor: 'pointer',
                                                                        height: '24px'
                                                                    }}
                                                                    onClick={() => handleTogglePassword('newPassword')}

                                                                >
                                                                    {showPassword.newPassword ? <Visibility /> : <VisibilityOff />}
                                                                </div>
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </FormControl>
                                            <FormControl fullWidth>
                                                <TextField
                                                    id="confirmPassword"
                                                    name="confirmPassword"
                                                    // type="password"
                                                    type={showPassword.confirmPassword ? 'text' : 'password'}

                                                    variant='outlined'
                                                    color='primary'
                                                    // label="Confirm Password*"
                                                    placeholder={""}
                                                    autoComplete="off"
                                                    sx={{ mb: 1.5 }}
                                                    inputlabelprops={{ shrink: true }}
                                                    {...register('confirmPassword', { required: true })}
                                                    error={Boolean(errors.confirmPassword)}
                                                    helperText={errors.confirmPassword ? errors.confirmPassword.message : ""}
                                                    inputProps={{
                                                        maxLength: 50,
                                                    }}
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <div
                                                                    style={{
                                                                        cursor: 'pointer',
                                                                        height: '24px'
                                                                    }}
                                                                    onClick={() => handleTogglePassword('confirmPassword')}
                                                                >
                                                                    {showPassword.confirmPassword ? <Visibility /> : <VisibilityOff />}
                                                                </div>
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </FormControl>
                                        </Stack>
                                    </>
                                }

                                <Stack direction="row" sx={{ flexGrow: '1', gap: 1 }}>
                                    {id && !(statuses?.loading || statuses?.error) &&
                                        <>

                                            <FormControl fullWidth>
                                                <Typography variant='body1' sx={{ mb: 1, width: '100%' }}>Status<span style={{ color: 'red' }}>*</span></Typography>
                                                {/* <Select
                                                    labelId="select-status.id-label"
                                                    id="accountStatus.id"
                                                    name="accountStatus.id"
                                                    // label="Status*"
                                                    defaultValue={entity?.value?.accountStatus.id || "-1"}
                                                    {...register('accountStatus.id')}
                                                    sx={{
                                                        mb: 1.5, border: 0, height: '40px', maxWidth: '350px', backgroundColor: '#fff', '&:hover': {
                                                            backgroundColor: '#fff'
                                                        },
                                                    }}
                                                >
                                                    <MenuItem key={-1} value={-1}>-Select-</MenuItem>
                                                    {statuses?.value?.map((status) => (
                                                        <MenuItem key={status.id} value={status.id}>{status.name}</MenuItem>
                                                    ))}
                                                </Select> */}
                                                <Controller
                                                    name="accountStatus.id"
                                                    control={control}
                                                    defaultValue={entity?.value?.accountStatus.id || "-1"}
                                                    render={({ field }) => (
                                                        <Select
                                                            {...field}
                                                            labelId="select-status.id-label"
                                                            id="accountStatus.id"
                                                            name="accountStatus.id"
                                                            sx={{
                                                                mb: 1.5, border: 0, height: '40px', maxWidth: '350px', backgroundColor: '#fff', '&:hover': {
                                                                    backgroundColor: '#fff'
                                                                },
                                                            }}
                                                        >
                                                            <MenuItem key={-1} value={-1}>
                                                                -Select-
                                                            </MenuItem>
                                                            {statuses?.value?.map((status) => (
                                                                <MenuItem key={status.id} value={status.id}>{status.name}</MenuItem>
                                                            ))}
                                                        </Select>
                                                    )}
                                                />
                                            </FormControl>
                                        </>
                                    }
                                </Stack>
                            </Stack>
                            <Stack direction="column" size={{ xs: 12, sm: 12, lg: 12, mt: 2 }} sx={{ flexGrow: '1', gap: 1 }}>
                                <FormControl fullWidth>

                                    <Stack direction="row" spacing={3} sx={{ mb: 0.5, mt: 2, justifyContent: 'center' }} >
                                        <Button type={"submit"} variant="contained" color="primary" size="small"
                                            sx={{ fontSize: 16, fontWeight: 600 }}
                                        >
                                            Save
                                        </Button>
                                        <Button onClick={() => reset()} variant="outlined" size="small"
                                            sx={{ backgroundColor: 'buttonVar.reset', color: 'buttonVar.resetText', fontSize: 16, fontWeight: 600 }}
                                        >
                                            Reset
                                        </Button>
                                        <Button onClick={() => history.navigate(-1)} variant="outlined"
                                            size="small" sx={{ backgroundColor: 'buttonVar.cancel', fontSize: 16, fontWeight: 600 }}  >
                                            Cancel
                                        </Button>
                                    </Stack>
                                </FormControl>
                            </Stack>
                        </form>
                    }
                </Stack>
            </Card>
        </React.Fragment >
    );
}
